import React, { Component, Fragment } from "react";
import AgentFocusColumnEditorModal from "./AgentFocusColumnEditorModal";
import AFColumnTestimonial from "./AFColumnTestimonial";
import { pmaActions } from "_store/_actions";
import { connect } from "react-redux";

export const DEFAULT_AGENT_FOCUS_SECTION_IMAGE =
  "https://d2onbxnrte2nim.cloudfront.net/non-covers/032526_PMA_BackCover_Graphic.png";

class AgentFocusColumn extends Component {
  state = {
    editQuadrantFormData: null,
    oldQuadrantData: [],
    selectedQuadrantNumber: null,
    titleEdit: false,
    maxMainTitleLength: 45,
    maxMainSubtitleLength: 57,
    filteredAreas: {},

    savingMessageShowing: false,
  };

  handleFormClose = () => {
    this.props.updateAgentFocusModalOpen(false);
    this.setState({
      titleEdit: false,
      savingMessageShowing: false,
    });
  };
  onEditFormSubmit = () => {
    const { editQuadrantFormData, oldQuadrantData } = this.state;
    let foundIndex = oldQuadrantData.findIndex(
      (x) => x.afAreaID === editQuadrantFormData.afAreaID,
    );
    oldQuadrantData[foundIndex] = editQuadrantFormData;
    this.props.setAgentFocusInfoList(oldQuadrantData);
    this.setState({
      savingMessageShowing: true,
    });
    setInterval(() => {
      this.setState({ savingMessageShowing: false });
    }, 5000);
  };
  openSelectedQuadrant = (quadrantNumber, titleEdit) => {
    this.props.updateAgentFocusModalOpen(true);
    this.setState({
      selectedQuadrantNumber: quadrantNumber,
      titleEdit: titleEdit,
      savingMessageShowing: false,
    });
  };
  componentDidMount = () => {
    if (this.props.printVersion) {
      require("./print.scss");
    } else {
      require("./editor.scss");
    }
    const { currentArea, agentFocusInfoList } = this.props;
    const quadrantSource = Array.isArray(agentFocusInfoList)
      ? agentFocusInfoList
      : [];

    this.props.updateAgentFocusModalOpen(false);
    let newObj = [...quadrantSource]
      .filter((quadrantObj) => quadrantObj.afAreaID === currentArea.mlsAreaID)
      .map((i) => ({ ...i }))[0];

    if (!newObj && currentArea.mlsAreaID.includes("DEMO")) {
      newObj = quadrantSource[0];
    }
    this.setState({
      oldQuadrantData: [...quadrantSource].map((i) => ({ ...i })),
      editQuadrantFormData: [...quadrantSource]
        .filter((quadrantObj) => quadrantObj.afAreaID === currentArea.mlsAreaID)
        .map((i) => ({ ...i }))[0],
    });
  };
  handleRestoreDefault = () => {
    const {
      selectedQuadrantNumber,
      editQuadrantFormData,
      oldQuadrantData,
      titleEdit,
    } = this.state;
    if (titleEdit) {
      this.setState({
        // mainTitle: oldTitle,
      });
    } else if (selectedQuadrantNumber >= 0) {
      let newObj = [...editQuadrantFormData].map((i) => ({ ...i }));
      let oldSelection = [...oldQuadrantData].map((i) => ({
        ...i,
      }))[selectedQuadrantNumber];
      newObj[selectedQuadrantNumber].text = oldSelection.text;
      this.setState({
        editQuadrantFormData: newObj,
      });
    }
  };
  handleInputChange = (e) => {
    const { editQuadrantFormData } = this.state;
    const target = e.target;
    const value = target.value;
    const name = target.name;
    let clonedEditQuadrantFormData = Object.assign(editQuadrantFormData, {
      [name]: value,
    });
    this.setState({
      editQuadrantFormData: clonedEditQuadrantFormData,
    });
  };
  applyToAllAreas = () => {
    console.log("applyToAllAreas");
  };

  render() {
    const {
      mlsAreas,
      agentFocusModalOpen,
      currentArea,
      printVersion,
      fromEditor,
      showAllEditButtons,
      hoData,
      agentData,
      testimonials,
    } = this.props;
    let { isMemberOfTeam, listgenUserID } = agentData || {};
    let { homeOwnerURLQRCodePath } = hoData || {};
    const { openSelectedQuadrant, handleInputChange, handleRestoreDefault } =
      this;
    const {
      editQuadrantFormData,
      oldQuadrantData,
      selectedQuadrantNumber,
      titleEdit,
      maxMainTitleLength,
      maxMainSubtitleLength,
      savingMessageShowing,
    } = this.state;

    if (listgenUserID === "104835") {
      isMemberOfTeam = true;
    }

    let quadrantStyles;
    let showButtons = fromEditor && showAllEditButtons;
    // let showButtons = true;
    let quadrantTitleStyles;
    if (editQuadrantFormData && Object.keys(editQuadrantFormData).length >= 1) {
      const {
        afAreaTitle,
        afAreaSubTitle,
        af1Title,
        af1SubTitle,
        af1Text,
        af2Title,
        af2SubTitle,
        af2Text,
        af3Title,
        af3SubTitle,
        af3Text,
        af4Title,
        af4SubTitle,
        af4Text,
      } = editQuadrantFormData;

      return (
        <Fragment>
          {editQuadrantFormData &&
            Object.keys(editQuadrantFormData).length >= 1 &&
            agentFocusModalOpen && (
              <div className="agent-focus-column-editor-modal-scope">
                <AgentFocusColumnEditorModal
                  oldQuadrantData={oldQuadrantData}
                  onCloseFn={this.handleFormClose}
                  handleInputChange={handleInputChange}
                  editQuadrantFormData={editQuadrantFormData}
                  onEditFormSubmit={this.onEditFormSubmit}
                  selectedQuadrantNumber={selectedQuadrantNumber}
                  handleRestoreDefault={handleRestoreDefault}
                  titleEdit={titleEdit}
                  mlsAreas={mlsAreas}
                  maxMainTitleLength={maxMainTitleLength}
                  maxMainSubtitleLength={maxMainSubtitleLength}
                  savingMessageShowing={savingMessageShowing}
                />
              </div>
            )}
          <div
            className={`${
              printVersion
                ? "print-april-2023-agent-focus-column"
                : "editor-april-2023-agent-focus-column"
            } ${quadrantStyles && quadrantStyles} `}
          >
            <div className="agent-focus-column-image-container">
              <img
                src="https://d2onbxnrte2nim.cloudfront.net/non-covers/081126_AUG-BackCvr_creamyBG_3.jpg"
                alt="Section Image"
                className="agent-focus-column-image"
              />{" "}
            </div>
            <div className="quadrant">
              <div className="quadrant-title-container">
                <div
                  className={`quadrant-title-text ${quadrantTitleStyles}`}
                  dangerouslySetInnerHTML={{ __html: afAreaTitle }}
                ></div>
                <div
                  className="quadrant-subtitle-text"
                  dangerouslySetInnerHTML={{
                    __html: afAreaSubTitle !== "-" ? afAreaSubTitle : "",
                  }}
                ></div>
              </div>
              <div className="quadrant-body">
                {fromEditor && showButtons && !agentFocusModalOpen && (
                  <div>
                    <div
                      className="quadrant-btn quadrant-title-btn"
                      onClick={() => openSelectedQuadrant(null, true)}
                    >
                      <div>Edit this section</div>
                    </div>
                    <div
                      className="quadrant-btn quadrant-btn-1"
                      onClick={() => openSelectedQuadrant(1)}
                    >
                      <div>Edit this section</div>
                    </div>
                    <div
                      className="quadrant-btn quadrant-btn-2"
                      onClick={() => openSelectedQuadrant(2)}
                    >
                      <div>Edit this section</div>
                    </div>
                    <div
                      className="quadrant-btn quadrant-btn-3"
                      onClick={() => openSelectedQuadrant(3)}
                    >
                      <div>Edit this section</div>
                    </div>
                    <div
                      className="quadrant-btn quadrant-btn-4"
                      onClick={() => openSelectedQuadrant(4)}
                    >
                      <div>Edit this section</div>
                    </div>
                  </div>
                )}
                <div className="section-container">
                  <div className="section-row">
                    <div
                      className={`${
                        1 === selectedQuadrantNumber &&
                        "selected-quadrant-section"
                      } quadrant-section section-1`}
                      // onClick={() => openSelectedQuadrant(1)}
                      key={1}
                    >
                      <div className="quadrant-section-title">
                        <p dangerouslySetInnerHTML={{ __html: af1Title }}></p>
                      </div>
                      {af1SubTitle && af1SubTitle !== "-" ? (
                        <div className="quadrant-section-title">
                          <p
                            dangerouslySetInnerHTML={{ __html: af1SubTitle }}
                          ></p>
                        </div>
                      ) : (
                        <div className="quadrant-section-title"></div>
                      )}

                      <div
                        className="quadrant-section-text"
                        dangerouslySetInnerHTML={{ __html: af1Text }}
                      ></div>
                    </div>

                    <div
                      className={`${
                        2 === selectedQuadrantNumber &&
                        "selected-quadrant-section"
                      } quadrant-section section-2`}
                      // onClick={() => openSelectedQuadrant(2)}
                      key={2}
                    >
                      <div className="quadrant-section-title">
                        <p dangerouslySetInnerHTML={{ __html: af2Title }}></p>
                      </div>
                      {af2SubTitle && af2SubTitle !== "-" ? (
                        <div className="quadrant-section-title">
                          <p
                            dangerouslySetInnerHTML={{ __html: af2SubTitle }}
                          ></p>
                        </div>
                      ) : (
                        <div className="quadrant-section-title"></div>
                      )}
                      <div
                        className="quadrant-section-text"
                        dangerouslySetInnerHTML={{ __html: af2Text }}
                      ></div>
                    </div>

                    <div
                      className={`${
                        3 === selectedQuadrantNumber &&
                        "selected-quadrant-section"
                      } quadrant-section section-3`}
                      // onClick={() => openSelectedQuadrant(3)}
                      key={3}
                    >
                      <div className="quadrant-section-title">
                        <p dangerouslySetInnerHTML={{ __html: af3Title }}></p>
                      </div>
                      {af3SubTitle && af3SubTitle !== "-" ? (
                        <div className="quadrant-section-title">
                          <p
                            dangerouslySetInnerHTML={{ __html: af3SubTitle }}
                          ></p>
                        </div>
                      ) : (
                        <div className="quadrant-section-title"></div>
                      )}
                      <div
                        className="quadrant-section-text"
                        dangerouslySetInnerHTML={{ __html: af3Text }}
                      ></div>
                    </div>

                    <div
                      className={`${
                        4 === selectedQuadrantNumber &&
                        "selected-quadrant-section"
                      } quadrant-section section-4`}
                      key={4}
                    >
                      <div className="quadrant-section-title">
                        <p dangerouslySetInnerHTML={{ __html: af4Title }}></p>
                      </div>
                      {af4SubTitle && af4SubTitle !== "-" ? (
                        <div className="quadrant-section-title">
                          <p
                            dangerouslySetInnerHTML={{ __html: af4SubTitle }}
                          ></p>
                        </div>
                      ) : (
                        <div className="quadrant-section-title"></div>
                      )}
                      <div
                        className="quadrant-section-text"
                        dangerouslySetInnerHTML={{ __html: af4Text }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <AFColumnTestimonial
            testimonials={testimonials}
            agentData={agentData}
            printVersion={printVersion}
            fromEditor={fromEditor}
            currentArea={currentArea}
            showAllEditButtons={showAllEditButtons}
          />
        </Fragment>
      );
    } else {
      return <div></div>;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    agentFocusModalOpen: state.pma.agentFocusModalOpen,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAgentFocusModalOpen: (isModalOpen) => {
      dispatch(pmaActions.updateAgentFocusModalOpen(isModalOpen));
    },
    setAgentFocusInfoList: (agentFocusInfoList) => {
      dispatch(pmaActions.setAgentFocusInfoList(agentFocusInfoList));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AgentFocusColumn);
